import { TaskGroupingOption } from "./GroupingConstants";
/**
 * Supported pivots for My Tasks view
 */ export var MyTasksViewPivotType = /*#__PURE__*/ function(MyTasksViewPivotType) {
    MyTasksViewPivotType["All"] = "all";
    /** User's task captures */ MyTasksViewPivotType["PrivateTasks"] = "privatetasks";
    /** Tasks assigned to user */ MyTasksViewPivotType["AssignedToMe"] = "assignedtome";
    /** User's flagged emails */ MyTasksViewPivotType["FlaggedEmails"] = "flaggedemails";
    /** Tasks marked as important/favorite by user */ MyTasksViewPivotType["Important"] = "important";
    /** Tasks due this week */ MyTasksViewPivotType["ThisWeek"] = "thisweek";
    /** Tasks due soon (within the next 7 days) */ MyTasksViewPivotType["DueSoon"] = "duesoon";
    /** Tasks someone else is working on that I'm waiting for */ MyTasksViewPivotType["WaitingOnMe"] = "waitingonme";
    /** Tasks I delegated to others */ MyTasksViewPivotType["DelegatedTasks"] = "delegatedtasks";
    /** Tasks I'm tracking but not assigned to */ MyTasksViewPivotType["Tracking"] = "tracking";
    /** More options */ MyTasksViewPivotType["More"] = "more";
    return MyTasksViewPivotType;
}({});
/**
 * The default pivot type for My Tasks page
 */ export const DefaultMyTasksViewPivotType = "assignedtome";
export const MyTasksPivotGroupingConfig = {
    ["duesoon"]: {
        defaultGrouping: TaskGroupingOption.DueDate,
        allowOverride: false
    },
    ["assignedtome"]: {
        defaultGrouping: TaskGroupingOption.Priority,
        allowOverride: false
    },
    ["important"]: {
        defaultGrouping: TaskGroupingOption.DueDate,
        allowOverride: true
    },
    ["thisweek"]: {
        defaultGrouping: TaskGroupingOption.DueDate,
        allowOverride: true
    },
    ["privatetasks"]: {
        defaultGrouping: TaskGroupingOption.Plan,
        allowOverride: true
    },
    ["all"]: {
        defaultGrouping: TaskGroupingOption.Plan,
        allowOverride: true
    },
    ["flaggedemails"]: {
        defaultGrouping: TaskGroupingOption.Plan,
        allowOverride: true
    }
};
/**
 * Supported pivots for My Plans view
 */ export var MyPlansPagePivotType = /*#__PURE__*/ function(MyPlansPagePivotType) {
    /** User's recent plans */ MyPlansPagePivotType["Recent"] = "recent";
    /** Shared plans accessible to user */ MyPlansPagePivotType["Shared"] = "shared";
    /** User's personal plans */ MyPlansPagePivotType["Personal"] = "personal";
    /** User's pinned plans */ MyPlansPagePivotType["Pinned"] = "pinned";
    /** Plans in teams accessible to user */ MyPlansPagePivotType["MyTeams"] = "myTeams";
    /** Recommended plans */ MyPlansPagePivotType["Recommended"] = "recommended";
    return MyPlansPagePivotType;
}({});
/**
 * The default pivot type for My Plans page
 */ export const DefaultMyPlansPagePivotType = "recent";
